import { useEffect } from "react";

import { cookieConsentConfig } from "./constants";

const isSnap = typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

export const ExternalScriptsLoader = () => {
  useEffect(() => {
    if (isSnap) return;

    const w = window as any;
    // Cookie Consent Script
    const cookieScript = document.createElement("script");
    cookieScript.src = "//www.termsfeed.com/public/cookie-consent/4.1.0/cookie-consent.js";
    cookieScript.async = true;
    cookieScript.charset = "UTF-8";
    cookieScript.onload = () => {
      if (w.cookieconsent) {
        w.cookieconsent.run(cookieConsentConfig);
      }
    };
    document.body.appendChild(cookieScript);

    // OpenReplay (Tracking)
    const openReplayScript = document.createElement("script");
    openReplayScript.type = "text/javascript";
    openReplayScript.text = `
      var initOpts = {
        projectKey: "nMk6pMLWB97UY1guQVKQ",
        defaultInputMode: 2,
        obscureTextNumbers: false,
        obscureTextEmails: true,
      };
      var startOpts = { userID: "" };
      (function(A,s,a,y,e,r){
        r=window.OpenReplay=[e,r,y,[s-1, e]];
        s=document.createElement('script');s.src=A;s.async=!a;
        document.getElementsByTagName('head')[0].appendChild(s);
        r.start=function(v){r.push([0])};
        r.stop=function(v){r.push([1])};
        r.setUserID=function(id){r.push([2,id])};
        r.setUserAnonymousID=function(id){r.push([3,id])};
        r.setMetadata=function(k,v){r.push([4,k,v])};
        r.event=function(k,p,i){r.push([5,k,p,i])};
        r.issue=function(k,p){r.push([6,k,p])};
        r.isActive=function(){return false};
        r.getSessionToken=function(){};
      })("//static.openreplay.com/latest/openreplay.js",1,0,initOpts,startOpts);
    `;
    document.body.appendChild(openReplayScript);

    // DonorBox script
    const donorboxScript = document.createElement("script");
    donorboxScript.src = "https://donorbox.org/install-popup-button.js";
    donorboxScript.defer = true;
    donorboxScript.id = "donorbox-popup-button-installer";
    document.body.appendChild(donorboxScript);

    // DonorBox config
    w.DonorBox = { widgetLinkClassName: "custom-dbox-popup" };

    // Clean up on unmount
    return () => {
      document.body.removeChild(cookieScript);
      document.body.removeChild(openReplayScript);
      document.body.removeChild(donorboxScript);
    };
  }, []);

  return null;
};
